import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import CellularSubscriber from './CellularSubscriber';
import TvSubscriber from './TvSubscriber';
import InternetSubscriber from './InternetSubscriber';
import { isMobile } from 'react-device-detect';
import './SubscriberSwiper.scss';
import { worldEnum, productType, TAB_ENUM } from '../../Constant';
import { setSelectedSubscriber } from '../../SelfCareSlice';
import { connect } from 'react-redux';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import EnergySubscriber from './EnergySubscriber';
import OtpExtendedButton from '../../../../Block/SelfcareExtendedOtpButtonBlock/SelfcareExtendedOtpButton';

const SubscriberSwiper = ({
  subscribersByProduct,
  selectedSubscriber,
  setSelectedSubscriber,
  worldType,
  isFetchLoginData,
  isFetchData,
  isOtpAuthenticated
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [subscriberPerSlide, setSubscriberPerSlide] = useState([]);
  const [subscriberList, setSubscriberList] = useState([]);
  const subscriberRefs = useRef([]);
  const componentRef = useRef(null);
  const slidePerView = 5;
  const [hasReachedTop, setHasReachedTop] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [isScrollingUp, setIsScrollingUp] = useState(false);
  const fixHeaderHeight = isMobile ? 56 : 88;

  const cellularWord = worldType == TAB_ENUM.Cellular || worldType == TAB_ENUM.Abroad;

  useEffect(() => {
    if (cellularWord) {
      setSubscribers();
    }
  }, [isFetchLoginData, subscribersByProduct]);

  useEffect(() => {
    if (!cellularWord) {
      if (isFetchData) {
        setSubscribers();
      }
    }
  }, [isFetchData]);

  function setSubscribers() {
    setSubscriberList([]); //reset
    var subscribers = subscribersByProduct[worldType];
    if (subscribers) {
      let slidesToDisplay = isMobile ? subscribers : subscribers.slice(0, slidePerView);
      const selectedSubIndex = subscribers.findIndex(s => s.productSubscriberNo == selectedSubscriber.productSubscriberNo)
      if (selectedSubIndex > slidePerView - 1) {
        const startIndex = selectedSubIndex + 1 - slidePerView;
        slidesToDisplay = subscribers.slice(startIndex, startIndex + slidePerView);
        setCurrentIndex(startIndex);
      }
      setSubscriberList(subscribers);
      setSubscriberPerSlide(slidesToDisplay);
    }

  }

  const handlePrev = () => {
    if (currentIndex === 0) return;
    let prevIndex = currentIndex - 1;
    setCurrentIndex(prevIndex);
    setSubscriberPerSlide(subscriberList.slice(prevIndex, slidePerView + prevIndex));
  };
  const handleNext = () => {
    if (currentIndex === subscriberList.length - slidePerView) return;
    let nextIndex = currentIndex + 1;
    setCurrentIndex(nextIndex);
    setSubscriberPerSlide(subscriberList.slice(nextIndex, nextIndex + slidePerView));
  };

  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > lastScrollTop) {
      setIsScrollingUp(false);
    } else {
      setIsScrollingUp(true);
    }
    if (!isScrollingUp && hasReachedTop) {
      return;
    }
    if (componentRef.current) {
      const elementTop = componentRef.current.getBoundingClientRect().top - fixHeaderHeight;
      if (elementTop <= 0) {
        if (!hasReachedTop) {
          setHasReachedTop(true);
        }
      } else if (isScrollingUp) {
        if (hasReachedTop) {
          setHasReachedTop(false);
        }
      }
    }
    setLastScrollTop(scrollTop);
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [hasReachedTop, lastScrollTop, isScrollingUp]);

  const getSubscriberByWorld = (subscriber, subsIsSelected) => {
    switch (worldEnum[worldType]) {
      case worldEnum.Abroad: {
        return <CellularSubscriber subscriber={subscriber} isAbroad={true} showAirplane={subscriber?.abroadSocInd === 'Y'} />;
      }
      case worldEnum.Cellular:
        return <CellularSubscriber subscriber={subscriber} />;
      case worldEnum.TV:
        return <TvSubscriber subscriber={subscriber} />;
      case worldEnum.Internet:
        return <InternetSubscriber subscriber={subscriber} />;
      case worldEnum.Energy:
        return <EnergySubscriber subscriber={subscriber} />;
      default:
        return null;
    }
  };

  const handleSubscriberClick = (subscriber, index) => {
    setSelectedSubscriber(subscriber);
    sessionStorage.setItem("selectedBan", subscriber.ban);
    if (isMobile && subscriberRefs.current[index]) {
      subscriberRefs.current[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  };
  const subscriberWithExtendedBtn = subscriberList.length == 1 && cellularWord && isOtpAuthenticated;
  const showSubscriberList = subscriberList.length > 1 || subscriberWithExtendedBtn;
  return (
    <>
      {showSubscriberList && (
        <div ref={componentRef} className={`subscriberContainer ${hasReachedTop ? 'sticky' : ''}`} >
          <div className={`subscribersSwiper ${subscriberList.length <= 2 ? 'center' : ''} `}>
            {!isMobile && subscriberList.length > slidePerView && currentIndex > 0 && (
              <Image className='swiper-arrow right' src={require('./icon/arrow-right.svg')} onClick={handlePrev} />
            )}

            {subscriberPerSlide?.map((s, index) => {
              const selectedSub = selectedSubscriber ?? subscriberList[0];
              const isSelected = selectedSub.productSubscriberNo == s.productSubscriberNo;
              return (
                <div key={index} ref={(el) => (subscriberRefs.current[index] = el)}>
                  <div
                    className={`subscriber_item ${worldType} ${isSelected ? 'selected' : ''} ${subscriberWithExtendedBtn ? 'single' : ''}`}
                    onClick={() => handleSubscriberClick(s, index)}>
                    {getSubscriberByWorld(s, isSelected)}
                  </div>
                  {isSelected && (
                    <div className="pointer"></div>
                  )}
                </div>
              );
            })}
            {!isMobile && subscriberList.length > slidePerView && currentIndex < subscriberList.length - slidePerView && (
              <Image className='swiper-arrow left' src={require('./icon/arrow-left.svg')} onClick={handleNext} />
            )}
            {(cellularWord && isOtpAuthenticated) && <OtpExtendedButton />}
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    worldType: state.selfcarePage.epiData.worldType,
    subscribersByProduct: state.selfcarePage.subscribersByProduct,
    selectedSubscriber: state.selfcarePage.selectedSubscriber,
    isFetchLoginData: state.selfcarePage.isFetchLoginData,
    isFetchData: state.selfcarePage.isFetchData,
    isOtpAuthenticated: state.authentication.loginData.isOtpAuthenticated,
  };
};

const mapDispatchToProps = { setSelectedSubscriber };

export default connect(mapStateToProps, mapDispatchToProps)(SubscriberSwiper);
